import { InjectionToken, Signal } from '@angular/core';
import { SlideBuilderConfig } from '../models/slide-builder-config';

export const SLIDE_BUILDER_CONFIG = new InjectionToken<SlideBuilderConfig>('');
export const EXPORT_PDF_MODE = new InjectionToken<boolean>('');
export const PREVIEW_MODE = new InjectionToken<boolean>('');
export const IS_BRANCHING_SLIDE = new InjectionToken<Signal<boolean>>('');
